<template>
  <div
    class="container my-1"
    style="min-height: 500;"
  >
    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <div class="television mt-1">
        <div class="card">
          <div class="card-body">
            Truyền hình
          </div>
        </div>
      </div>
    </b-overlay>
  </div>
</template>
<script>
import {
  BOverlay,

} from 'bootstrap-vue';
import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store'
import { Vietnamese } from 'flatpickr/dist/l10n/vn';
import { showToast, useRouter } from '@/@core/utils/utils';
import moment from 'moment';

export default {
  components: {
    BOverlay,
  },
  data() {
    return {
      dataParent: [],
      moment,
    }
  },
  watch: {
    // "$route.params.slug"(value) {
    //   this.refetchData(value)
    // }
  },
  setup(props, context) {
    const { route, router } = useRouter();
    const loading = ref(true)
    const perPage = ref(30)
    const total = ref(0)
    const currentPage = ref(1)
    const searchQuery = ref('')
    const localSearchQuery = ref('')
    const itemsData = ref([]);
    const start_date = ref('');
    const end_date = ref('');
    const refListTable = ref(null)
    const start_time = ref('');
    const end_time = ref('')
    const currentSlug = ref('')
    if (route.value.params.slug) {
      currentSlug.value = route.value.params.slug
    }

    const tableColumns = [
      {
        key: 'index', sortable: false, label: 'ID', thAttr: { width: '5%' }, tdClass: 'text-center',
      },
      { key: 'name', sortable: false, label: 'Tiêu đề' },
      { key: 'published_at', label: 'Thời gian', thAttr: { width: '12%' } },
    ];
    const fetchAll = (slug) => {
      currentSlug.value = slug
      store.dispatch('home/television', {
        keyword: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        slug: currentSlug.value,
        start_date: start_time.value,
        end_date: end_time.value,
      })
        .then(response => {
          loading.value = false
          const result = response.data;
          if (result.code === 200) {
            itemsData.value = result.data.data
            total.value = result.data.total;
          } else {
            itemsData.value = []
            showToast(result.message, { variant: 'danger' })
          }
        })
    }
    fetchAll(currentSlug.value)
    const dataMeta = computed(() => {
      const localItemsCount = refListTable.value ? refListTable.value.localItems.length : 0
      return {
        from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
        to: perPage.value * (currentPage.value - 1) + localItemsCount,
        of: total.value,
      }
    })

    watch([currentPage, perPage, searchQuery, start_date, end_date], () => {
      refetchData(currentSlug.value);
    });

    const refetchData = (slug, flag = false) => {
      if (slug != currentSlug.value || flag == true) {
        localSearchQuery.value = '';
        article_type.value = ''
        department_id.value = ''
        end_time.value = ''
        start_time.value = ''
      }
      loading.value = true;
      fetchAll(slug);
    };
    const updateSearchQuery = () => {
      loading.value = true;
      if (start_time.value > end_time.value) {
        showToast('Đến ngày phải lớn hơn từ ngày', { variant: 'danger' });
        return false;
      }
      start_date.value = start_time.value;
      end_date.value = end_time.value

      searchQuery.value = localSearchQuery.value
    }

    const config_time = ref({
      dateFormat: 'd-m-Y',
      wrap: true,
      locale: Vietnamese, // locale for this instance only
    });
    return {
      tableColumns,
      dataMeta,
      itemsData,
      currentPage,
      perPage,
      loading,
      refListTable,
      localSearchQuery,
      total,
      config_time,
      start_time,
      end_time,
      updateSearchQuery,
      refetchData,
      currentSlug,
    }
  },
  methods: {
    refreshData(slug) {
      this.refetchData(slug, true)
    },

  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
